import { render, staticRenderFns } from "./terms_of_service.vue?vue&type=template&id=2282db84&scoped=true"
import script from "./terms_of_service.vue?vue&type=script&lang=js"
export * from "./terms_of_service.vue?vue&type=script&lang=js"
import style0 from "./terms_of_service.vue?vue&type=style&index=0&id=2282db84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282db84",
  null
  
)

export default component.exports